var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "eye",
    d: "M7.106,8.988A7.44,7.44,0,0,1,4.27,8.216,13.244,13.244,0,0,1,.242,5.1.849.849,0,0,1,.231,3.921,12.621,12.621,0,0,1,4.648.622,7.008,7.008,0,0,1,7.95.016a7.615,7.615,0,0,1,2.74.752,12.722,12.722,0,0,1,3.67,2.7c.115.118.22.242.337.358a1.33,1.33,0,0,1,.3.512v.354a4.365,4.365,0,0,1-1.145,1.332,12.111,12.111,0,0,1-3.173,2.221A7.332,7.332,0,0,1,7.507,9Q7.308,9,7.106,8.988ZM4.276,4.481A3.116,3.116,0,0,0,7.492,7.5a3.122,3.122,0,0,0,3.24-2.986A3.114,3.114,0,0,0,7.523,1.5H7.5A3.118,3.118,0,0,0,4.276,4.481ZM7.5,6.641A2.234,2.234,0,0,1,5.2,4.5,2.234,2.234,0,0,1,7.51,2.359,2.232,2.232,0,0,1,9.8,4.506,2.235,2.235,0,0,1,7.5,6.641Z",
    fill: "#224e86"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/EyeIcon.c7164de35bf20da8be925895a38e52fd.svg";
export { ForwardRef as ReactComponent };